import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import SEO from "../components/SEO";
import { motion } from "framer-motion"; // Import framer-motion
import julius2 from '../assets/julius2.jpg';
import juliusvideo1 from '../assets/juliusvideo1.mp4';
import juliusvideo2 from '../assets/juliusvideo2.mp4';
import juliusvideo4 from '../assets/juliusvideo4.mp4';
import ServicesCard from "../components/Services";
import JuliusMission from "../assets/JuliusMission.jpg";
import JuliusVision from "../assets/JuliusVision.jpg"

const Home = () => {
  return (
    <>
    {/** Work done by MelTech  */}
      <SEO
        title="Coach Julius Adeleke - Professional Tennis Coach in the US"
        description="Julius Adeleke, founder of Adeleke Tennis Academy, offers world-class tennis coaching for players of all levels in the United States."
        keywords="Tennis Coach, Julius Adeleke, Adeleke Tennis Academy, US tennis lessons, tennis training"
        url="https://www.adeleketennisacademy.com"
        image="https://julius-s-adeleke.web.app/public/julius.jpg"
      />
    <div>            
<Container fluid className="d-flex flex-column justify-content-center align-items-center text-center" style={{ paddingTop: "100px" }}>
{/* Hero Background Image Section */}
<div
  style={{
    width: "100%",
    height: "85vh",
    backgroundImage: `url(${julius2})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center 35%", // prevents head cutoff
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
  }}
>
  {/* Dark overlay for readability */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.45)",
    }}
  />

  <div style={{ position: "relative", zIndex: 2 }}>
  <h2 className="fw-bold">Build Your Tennis Game</h2>
  <p className="fs-6">Train with Coach Julius</p>

  <Button variant="light" size="md" href="/contact" className="mt-3">
    Get Started
  </Button>
</div>
</div>

        {/* Text Content */}
        <Row className="w-100 mt-4 fs-2">
          <Col>
            <motion.p
              className="fs-6 text-white"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
            >
              Hello, I'm <br />
              <span className="fw-bold mt-1 fs-2" style={{ fontSize: 20}}> Coach Julius S Adeleke.</span> 
              <span className="text-white fs-3" style={{ fontFamily: 'Times New Roman'}}>  Founder of Adeleke Tennis Academy (ATA). </span>
            </motion.p>
          </Col>
        </Row>
        
            {/* Hero Section */}
      <div className="mt-2 text-white" style={{ fontFamily: 'Times New Roman'}}>
        <h3 className="fw-bold fs-2">Don't Miss Out.</h3>
        <p className="fs-3">Join hundreds of students already <span style={{ color: "blue"}}>transforming their tennis skills</span> with me.</p>
      </div>

        {/* Call to Action Button */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          whileHover={{ scale: 1.1 }}
        >
          <Button variant="dark" size="lg" href="/contact" className="mb-5 fs-1">
            Book a Session
          </Button>
        </motion.div>
        <div className="mission-vision-section text-white py-5">
      <Container>
        {/* Mission */}
        <Row className="align-items-center mb-5">
          <Col xs={12} lg={6}>
            <h3 className="fw-bold">Mission</h3>
            <p>
              At Adeleke Tennis Academy, my mission is to guide athletes of all levels
              to reach their full potential through disciplined training, personalized coaching, 
              and mental toughness. I strive to develop not only skilled tennis players 
              but also confident individuals, on and off the court.
            </p>
          </Col>
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <img
              src={JuliusMission}
              alt="Mission Statement"
              className="img-fluid rounded shadow w-100"
              style={{ objectFit: "cover", maxHeight: "350px" }}
            />
          </Col>
        </Row>

        {/* Vision */}
        <Row className="align-items-center flex-column-reverse flex-lg-row">
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <img
              src={JuliusVision}
              alt="Vision Statement"
              className="img-fluid rounded shadow w-100"
              style={{ objectFit: "cover", maxHeight: "350px" }}
            />
          </Col>
          <Col xs={12} lg={6}>
            <h3 className="fw-bold">Vision</h3>
            <p>
              I envision becoming a global symbol of excellence in tennis coaching,
              empowering future champions and fostering a culture of passion, resilience, 
              and sportsmanship. From local courts to international arenas, I aim to inspire 
              every player to dream bigger and play harder.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
      </Container>

      <div>
        <ServicesCard />
      </div>
      

      {/* Video Section */}
      <Container style={{ paddingTop: 50}}>
        <motion.h3
          className="text-white text-center mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.5 }}
        >
          Watch Coach Julius in Action
        </motion.h3>

        <Row className="g-4">
          {[juliusvideo1, juliusvideo2, juliusvideo4].map((video, index) => (
            <Col key={index} xs={12} sm={6} md={4}>
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: index * 0.3 }}
                whileHover={{ scale: 1.05 }}
              >
                <Card className="bg-dark text-white">
                  <Card.Body>
                    <video controls className="w-100 rounded">
                      <source src={video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
    </>
  );
};

export default Home;
